<template>
  <div class="modal fade bs-example-modal-lg concierge-modal" id="concierge-modal" aria-hidden="true"
       aria-labelledby="exampleGrid" role="dialog">
    <div class="modal-dialog modal-simple modal-center modal-medium">
      <div class="modal-content">
        <form autocomplete="off">
          <div class="modal-header">
            <div class="container">
              <div class="row header">
                <div class="col-8">
                  <h4 class="modal-title">{{ $t('button.generate_concierge') }}</h4>
                </div>
                <div class="col-4">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                          @click.prevent="closeConciergeModal('#concierge-modal')">
                    <span aria-hidden="true" class="close-btn">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="form-group form-material">
                  <label class="control-label" for="concierge-email">{{ $t('input.email') }}</label>
                  <input type="text" class="form-control" id="concierge-email" v-model="conciergeData.email"/>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group form-material">
                  <v-multiselect
                    @input="selectRental"
                    v-model="value"
                    :options="options"
                    :multiple="true"
                    :close-on-select="false"
                    group-values="libs"
                    group-label="language"
                    :group-select="true"
                    track-by="name"
                    label="name"
                    :searchable="false"
                    :selectLabel="$t('selectLabel')"
                    :selectGroupLabel="$t('selectGroupLabel')"
                    :selectedLabel="$t('selectedLabel')"
                    :deselectLabel="$t('deselectLabel')"
                    :deselectGroupLabel="$t('deselectGroupLabel')"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group form-material">
                  <label class="control-label" for="concierge-year">{{ $t('input.year') }}</label>
                  <select id="concierge-year" class="form-control" v-model="conciergeData.year">
                    <option v-for="n in 14">{{ 2014 + n }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center">
            <button v-if="!smallLoading" type="button" class="btn waves-effect waves-classic btn-cancel"
                    id="concierge-modal-close" @click.prevent="closeConciergeModal('#concierge-modal')"
                    data-dismiss="modal">{{ $t("button.cancel") }}
            </button>
            <button v-if="!smallLoading" type="submit"
                    :class="`btn btn-primary waves-effect waves-classic btn-save ${smallLoading ? 'disabled' : ''}`"
                    @click.prevent="generateConciergeData()">{{ $t('analytics.index.export_analysis.download_super_concierge') }}
            </button>
            <v-loading :isLoading="smallLoading" :height="50" :width="50" :viewbox="'0 0 50 50'" :cx="25" :cy="25"
                       :r="22" :isHeightAuto="true"></v-loading>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import mixin from '../../mixins/mixin';
import analyticService from '../../services/analytics';
import moment from 'moment';

export default {
  name: 'Concierge',
  data() {
    return {
      conciergeData: {
        year: moment().year(),
        email: this.email,
        rentalIds: [],
      },
      smallLoading: false,
      value: [],
      options: [],
    };
  },
  props: {
    rentals: Array,
    email: String,
    groups: Array,
  },
  components: {
    VLoading: require('components/loading/loading.vue'),
    VMultiselect: Multiselect,
  },
  mixins: [mixin],
  mounted() {
    this.conciergeData.email = this.email;
  },
  watch: {
    groups(newValue) {
      if (newValue.length) {
        this.generateGroups();
      }
    },
    email(newValue) {
      this.conciergeData.email = newValue;
    },
    accountLang(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.generateGroups();
      }
    },
  },
  methods: {
    openConciergeModal() {
      if (this.rentals && this.rentals.length > 0) {
        this.openModal('#concierge-modal');
      } else {
        toastr.error(this.$t('rentals.index.no_result'));
      }
    },
    selectRental(rental) {
      this.value = rental;
    },
    async generateConciergeData() {
      this.smallLoading = true;
      this.value.map(val => this.conciergeData.rentalIds.push(val.id));
      await analyticService.generateConciergeData(this, this.conciergeData);
      this.value = [];
    },
    closeConciergeModal(modalName) {
      this.conciergeData = {
        email: this.email,
        rentalIds: [],
        year: moment().year(),
      };
      this.value = [];
      this.closeModal(modalName);
    },
    generateGroups() {
      this.options = [];
      this.groups.forEach((group) => {
        const option = {
          language: '',
          libs: [],
        };
        option.language = group.name === 'others' ? this.$t('groups.others') : group.name;
        group.rentals.forEach((item) => {
          option.libs.push({ name: item.name, id: item.id });
        });
        this.options.push(option);
      });
    },
  },
  computed: {
    accountLang() {
      return this.$store.getters.account.lang;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Concierge.vue?606309d8